import { render } from "./AccountSidebar.vue?vue&type=template&id=59958364&scoped=true"
import script from "./AccountSidebar.vue?vue&type=script&lang=js"
export * from "./AccountSidebar.vue?vue&type=script&lang=js"

import "./AccountSidebar.vue?vue&type=style&index=0&id=59958364&lang=scss"
import "./AccountSidebar.vue?vue&type=style&index=1&id=59958364&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59958364"]])

export default __exports__